import React, {useEffect, useState} from "react";
import {FormattedMessage} from "react-intl";
import GlobalConst from "../../constants/GlobalConst";
import {useDispatch, useSelector} from "react-redux";
import {selectLocale} from "../../stores/account/account.selectors";
import {setContestPick} from "../../stores/pickX/pickX.thunks";

import "./ContestCard.style.scss";
import {selectSelectedParlay} from "../../stores/pickX/pickX.selectors";
import useContestModal from "../../hooks/useContestModal";
import {ContestPickType, ParlayType} from "../../constants/PickXEnums";
import {selectGameById} from "../../stores/sports/sports.selectors";
import {getTeamLogoUrl} from "../../utils/SportUtils";
import GameMatchUpInfo from "../GameMatchUpInfo/GameMatchUpInfo";
import {getStartTime} from "../../utils/timeUtils";
import moment from "moment";
import {SeasonsAbvrMap} from "../../constants/SportsConst";

const ContestCard = ({contest, disabled}) => {
    const dispatch = useDispatch();
    const locale = useSelector(selectLocale);
    const openContestModal = useContestModal();
    const selectedParlay = useSelector(selectSelectedParlay);
    const playerPictureUrl = `${GlobalConst.CDN.BASEURL}images/Players/${GlobalConst.LEAGUES_BY_SPORT_ID[contest.SportId]}/${contest.PlayerId}.png`;

    const contestPickSelection = selectedParlay?.ContestsPicks[contest.Id]?.Pick;
    const game = useSelector(state=>selectGameById(state, contest.GameId));
    const teamKey = game?.HomeTeamId === contest.player?.TeamId ? game?.HomeTeamKey : game?.AwayTeamKey;
    const teamLogoUrl = getTeamLogoUrl(contest.player.League, contest.player.TeamId, `${contest.player.League}Player`,teamKey,null);

    const [previousLineValue, setPreviousLineValue] = useState(null);
    const [lineValueDirection, setLineValueDirection] = useState(null);

    useEffect(() => {
        if (previousLineValue !== null) {
            setLineValueDirection(contest.LineValue > previousLineValue ? 'Up' : 'Down');

            const timer = setTimeout(() => {
                setLineValueDirection(null);
            }, 3000);

            return () => clearTimeout(timer);
        }
        setPreviousLineValue(contest.LineValue);
    }, [contest.LineValue]);


    const isClosed = game.GL === 0;
    const isNotStarted = game.GL === 1;
    const isPlaying = game.GL % 1 > 0;
    const isGameStarted = game?.GL < 1;

    let extraClass = '';
    if (isClosed)
        extraClass = 'closed';
    else if (isNotStarted)
        extraClass = 'not-started';
    else if (isPlaying)
        extraClass = 'playing';

    const handleClick = (pick) => {
        dispatch(setContestPick({
            parlayId: selectedParlay.Id,
            contestId: contest.Id,
            pick,
            removeIfSame: selectedParlay.parlayType === ParlayType.CreateYourOwn
        }));
    };

    const handlePlayerClick = (contest) => {
        openContestModal(contest);
    }

    if(!contest)
        return null;

    // set a timer of 3 seconds to reset the direction
    // setTimeout(() => {
    //     setLineValueDirection(null);
    // }, 3000);

    const shouldHideUnderBtn = contest.SportId === 3 && contest.StatsKey !== "TCP"

    return (
        <div className={`CustomContestCard lineValue${lineValueDirection} ${extraClass}`}>
            <div className="header">
                <span className="gameTime">{getStartTime(moment(contest.game?.DateTime), locale)}</span>
                <span className="teams">
                    <GameMatchUpInfo playerTeamId={contest.player?.TeamId}
                                    awayTeamKey={contest.game?.AwayTeamKey}
                                    awayTeamId={contest.game?.AwayTeamId}
                                    homeTeamKey={contest.game?.HomeTeamKey}
                                    homeTeamId={contest.game?.HomeTeamId}
                    />
                </span>
            </div>
            <div className="body">
                <div className="teamLogo" style={{backgroundImage: `url(${teamLogoUrl})`}}/>
                <div className={`image ${contest.player?.League}`}
                     style={{backgroundImage: `url(${playerPictureUrl})`}}
                     onClick={() => {
                    handlePlayerClick(contest)
                }}>
                    {isPlaying && <div className="live-icon"/>}
                    {isClosed && <div className="closed-icon"/>}
                </div>
                <div className="info">
                    <div className="name">{contest.Name[locale]} <span className="position">- {contest.player.Position}</span></div>
                    <div className={`statsValue ${lineValueDirection ? `lineValue${lineValueDirection}`: 'gold-gradient-text'}`}>
                        {isGameStarted && (contest.IsUnder ?
                            <i className={'fa-solid fa-arrow-down arrow down'}/>
                            :
                            <i className="fa-solid fa-arrow-up arrow up"/>)} {isGameStarted ?
                        contest.StatsValue
                        :
                        contest.LineValue}
                    </div>
                    <div className={`stats ${lineValueDirection ? `lineValue${lineValueDirection}`: 'gold-gradient-text'}`}><FormattedMessage id={`StatsKeys.${contest.SportId}.${contest.StatsKey}.lineValueUnit`} /></div>
                </div>
                {contest.SeasonId && <div className="leagueInfo">{SeasonsAbvrMap[contest.SeasonId]}</div>}
            </div>
            {!isGameStarted && <div className="footer">
                <button
                    className={`btn ${contestPickSelection === ContestPickType.Over ? 'selected gold-background' : 'gold-gradient-text'}`}
                    onClick={() => handleClick(ContestPickType.Over)}
                    disabled={!isNotStarted || disabled}>
                    <FormattedMessage id={'lobbyView.betSlip.betSlip.more'}/>
                    <i className="fa-solid fa-arrow-up arrow up"/>
                </button>
                {!shouldHideUnderBtn && <button
                    className={`btn ${contestPickSelection === ContestPickType.Under ? 'selected gold-background' : 'gold-gradient-text'}`}
                    onClick={() => handleClick(ContestPickType.Under)}
                    disabled={!isNotStarted || disabled}>
                    <FormattedMessage id={'lobbyView.betSlip.betSlip.less'}/>
                    <i className={'fa-solid fa-arrow-down arrow down'}/>
                </button>}
            </div>}
            {isGameStarted && <div className="liveScore">
                    <span
                        className={`${contest.player.TeamId === contest.game.AwayTeamId ? 'playerTeam' : ''}`}>{contest.game?.AwayTeamKey} {contest.game.AwayTeamScore} </span>
                    vs
                    <span
                        className={`${contest.player.TeamId === contest.game.HomeTeamId ? 'playerTeam' : ''}`}> {contest.game.HomeTeamScore} {contest.game?.HomeTeamKey}</span>

            </div>}
        </div>
    );
}

export default ContestCard;